import { Navigate } from '@sorare/routing';
import { ANY_SPORT_PLAY_MISSIONS_CATEGORY_RARITY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { useMissionsPreferredRarity } from '#src/components/missions/RedirectToMissionsPage/useMissionsPreferredRarity.ts';

const PlayMissionsPage = () => {
  const { generateSportContextPath } = useSportContext();
  const rarity = useMissionsPreferredRarity();

  return (
    <Navigate
      replace
      to={generateSportContextPath(ANY_SPORT_PLAY_MISSIONS_CATEGORY_RARITY, {
        params: { category: 'play', rarity },
      })}
    />
  );
};

export default PlayMissionsPage;
